// extracted by mini-css-extract-plugin
module.exports = {"widget-ratings":"_1hXtGvTMJla2-zcxVqJmCZ","widget-ratings__item":"_3mb6MgzxYtQgSnvjmYVzDk"};